import axios from 'axios'
import { ElMessage } from "element-plus";
import { useMainStore } from '../pinia/main';
//超时时长
axios.defaults.timeout = 60000;

//接口请求地址
export const baseUrl = process.env.NODE_ENV === "development" ?
    // 'http://192.168.124.52:9020'
    // 'https://jyyh.net/match'
    'https://dev.tianchenhulian.com/match/'
    // : 'https://dev.tianchenhulian.com/match'//测试
    : 'https://jyyh.net/match'; //正式
//'https://jyyh.net/match'

axios.defaults.baseURL = baseUrl;


/**
 * http request 拦截器
 */
axios.interceptors.request.use(
    (config) => {
        const isLoading = config.headers.loading ?? true;
        const mainStore = useMainStore();
        mainStore.setGlobalLoading(isLoading);
        const token = mainStore.userInfo?.token;
        token && (config.headers['match-customer'] = token);
        return Promise.resolve(config);
    },
    (error) => {
        return Promise.reject(error);
    }
);


/**
 * http response 拦截器
 */
axios.interceptors.response.use(
    (response) => {
        const mainStore = useMainStore();
        const { status, data, headers } = response;
        mainStore.setGlobalLoading(false);
        if (status === 200) {
            switch (headers['content-type']) {
                case "application/vnd.ms-excel;charset=utf-8":
                    return Promise.resolve(data);
                default:
                    return Promise.resolve(data.t);
            }
        }

    },
    async (error) => {
        const mainStore = useMainStore();
        const { response } = error;
        mainStore.setGlobalLoading(false);
        switch (response?.status) {
            case 404:
                ElMessage({
                    message: response.data.message,
                    type: "error",
                });
                break;
            case 500: ElMessage({
                message: response.data.message,
                type: "error",
            });
                break;
            case 510:
                ElMessage({
                    message: response.data.message,
                    type: "error",
                });
                break;
            case 511:
                ElMessage({
                    message: response.data.message,
                    type: "error",
                });
                await mainStore.setUserInfo(null);
                await mainStore.setTabIndex("0");
                window.location.replace(process.env.NODE_ENV === "development" ? "/" : "/matchweb")
                break;

            default:

                break;
        }
    }
);


//post请求
export const post = (url, data, headers = {}) =>
    new Promise((resolve, reject) => {
        axios.post(url, data, headers).then(
            (response) => resolve(response)
        ).catch((err) => err.response?.data ? reject(err.response.data) : reject(err)
        );
    });

//get请求
export const get = (url, params = {}, headers = {}) =>
    new Promise((resolve, reject) => {
        axios.get(url, { params, headers }).then(
            (response) =>
                resolve(response)
        )
            .catch((err) => err.response?.data ? reject(err.response?.data) : reject(err)
            );
    });
